
window.HSJDEBUG = 0;
document.addEventListener("touchstart", e => {
    if(e.changedTouches[0].clientX < 30){
        window.HSJDEBUG ++ ;
        if(window.HSJDEBUG >= 20){
            window.HSJDEBUG = 0;
            let Url = window.location.href;
            let hasParams = Url.indexOf('?') !== -1;
            window.location.href = Url + (hasParams ? '&HSJDEBUG=1' : '?HSJDEBUG=1');
        }
    }else {
        window.HSJDEBUG = 0;
    }
});
